import { render, staticRenderFns } from "./google_button.vue?vue&type=template&id=495bf7e7&scoped=true&"
import script from "./google_button.vue?vue&type=script&lang=js&"
export * from "./google_button.vue?vue&type=script&lang=js&"
import style0 from "./google_button.vue?vue&type=style&index=0&id=495bf7e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495bf7e7",
  null
  
)

export default component.exports